<template>
    <section id="home-classified" class="home-classified bg-intro color-white">
        <!-- <div class="container px-0"> -->
        <div class="classified-wrapper">
            <div class="classified-image-wrapper">
                <div class="classified-image" data-aos="fade-in">
                    <img class="lazy blur lazyload" v-if="imageUrl" :src="thumbnail" :data-src="imageUrl" :alt="title">
                </div>
            </div>
            <div class="classified-content" data-aos="fade-up">
                <h2 class="classified-h2">{{ title || $t('title') }}</h2>
                <h3 class="classified-h3">{{ description || $t('description') }}</h3>

                <div ref="section" class="classified-list">
                    <div class="classified-item">
                        <div class="number-count">
                            <span class="number-hidden">{{ count1 }}+</span>
                            <count-to class="number-counting" ref="count1" :startVal="0" :endVal="count1" :duration="4000"
                                :suffix="studentCountSuffix" :autoplay=false></count-to>
                        </div>
                        <div class="academic">{{ $t('Student') }}</div>
                    </div>
                    <div class="classified-item">
                        <div class="number-count">
                            <span class="number-hidden">{{ count2 }}</span>
                            <count-to class="number-counting" ref="count2" :startVal="0" :endVal="count2" :duration="8000"
                                :suffix="courseCountSuffix" :autoplay=false></count-to>
                        </div>
                        <div class="academic">{{ $t('Program') }}</div>
                    </div>
                    <div class="classified-item">
                        <div class="number-count">
                            <span class="number-hidden">{{ count3 }}+</span>
                            <count-to class="number-counting" ref="count3" :startVal="0" :endVal="count3" :duration="5000"
                                :suffix="personnelCountSuffix" :autoplay=false></count-to>
                        </div>
                        <div class="academic">{{ $t('Personnel') }}</div>
                    </div>
                </div>
            </div>
            <!-- </div> -->
        </div>
    </section>
</template>

<script>
import countTo from 'vue-count-to';

export default {
    props: [
        'imageUrl', 'thumbnail', 'title', 'description',
        'studentCount', 'courseCount', 'personnelCount',
        'studentCountSuffix', 'courseCountSuffix', 'personnelCountSuffix'
    ],
    components: { countTo },

    data() {
        return {
            startVal: 0,
            endVal: 2017,

            scrollY: 0,

            isStart: false,

            count1: 3800,
            count2: 17,
            count3: 125,

            // title: `คณะสังคมศาสตร์ มหาวิทยาลัยศรีนครินทรวิโรฒ`,
            // description: `มุ่งหวังที่จะผลิตพัฒนาทรัพยากรบุคคลให้มี ความรอบรู้ในวิชาการ มีคุณธรรม
            //         จริยธรรม และมีความรับผิดชอบ สามารถนำความรู้ไปใช้ให้เป็นประโยชน์แก่สังคม`

        }
    },

    destroyed() {
        if (typeof window !== "undefined") {
            window.removeEventListener("scroll", this.scrollHandler);
        }
    },

    mounted() {
        this.onInit()
    },

    methods: {
        onInit() {

            this.count1 = parseInt(this.studentCount)
            this.count2 = parseInt(this.courseCount)
            this.count3 = parseInt(this.personnelCount)

            if (typeof window !== "undefined") {
                window.addEventListener("scroll", this.scrollHandler);

                this.scrollHandler();
            }
        },
        scrollHandler() {
            this.scrollY = window.scrollY;

            if (this.scrollY >= this.$refs.section.offsetTop - window.outerHeight && this.isStart == false) {


                // start1
                if (this.$refs.count1) {

                    this.isStart = true;
                    setTimeout(() => {
                        this.$refs.count1.start();
                        this.$refs.count2.start();
                        this.$refs.count3.start();
                    }, 500);

                }

            }
        },

    }
}
</script>

<style lang="scss" scoped>
.bg-intro {
    background-color: #636466;
}

.number-count {
    position: relative;

    .number-hidden {
        visibility: hidden;
    }

    .number-counting {
        position: absolute;
        left: 0;
        top: 0;
    }
}
</style>